module.exports = __webpack_public_path__ + "img/customer-icon-19.73c2402d.png";